<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-map-marker-radius </v-icon>
        <span class="headline mx-2">Attendance</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <template v-else>
      <v-row v-if="edit"> 
        <v-col cols="6">
          <v-checkbox
            v-model="form.require_location_checking"
          >
            <template v-slot:label>
              <div>
                Require Location Checking
              </div>
            </template>
          </v-checkbox>
        </v-col> 
      </v-row>
      <template v-else>
        <v-row>
          <v-col 
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium">Required Location Checking:</span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="employee.require_location_checking === 1" 
              color="success"
            >
              mdi-check-outline
            </v-icon>
            <v-icon 
              v-else 
              color="error"
            >
              mdi-close-outline
            </v-icon>        
          </v-col>
        </v-row>      
      </template>
    </template>
    <v-card-actions v-if="$hasPermissionTo(['update employee attendance settings'])">
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="info"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit=false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isMyProfile: {
        type: Boolean,
      },
    },

    data () {
      return {
        loading: false,
        edit: false,
        progressing: false,
        employee: {},
        form: {
          require_location_checking: null,
        },
      }
    },

    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadData()
          }
        },
      },
    },

    methods: {
      loadData () {
        this.loading = true
          
        this.$api.employees().show(this.employeeUid)
          .then(res => {
            this.employee = res.data
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },

      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.employee[key]
        })
 
        this.edit = true
      },

      submitForm () {
        this.progressing = true

        this.$api.employeeAttendanceSettings().update(this.employeeUid, { require_location_checking: this.form.require_location_checking })
          .then(res => {
            this.loadData()
            this.$snack({
              message: 'Setting updated successfully',
            })
          })
          .catch(() => {})
          .then(() => {
            this.edit = false
            this.progressing = false 
          })
      },

    },
  }
</script>
